

































































































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import {Actions, Endpoints, Mutations} from '@/ts/store/Constants';
import SharedFacilityFlyOut from '@/components/Admin/Panels/SharedFacilityFlyOut.vue';
import ConfirmPopup from '@/components/Admin/Panels/ConfirmPopup.vue';
import ProjectsData from '@/ts/ProjectsData';
import axios from 'axios';

@Component({
    components: {
        SharedFacilityFlyOut,
        ConfirmPopup,
    },
    computed: {
        ...mapGetters({
            confirmPopupVisibility: 'ConfirmPopup/getConfirmPopupVisibility',
            projectAllFacilities: 'SharedFacilities/getProjectAllFacilities',
        }),
    },
})
export default class SharedFacilities extends Vue {
    public activeFacility: number|null = null;
    public actionType: string = '';

    constructor() {
        super();
    }

    get projects(): ProjectsData[] {
        return this.$store.getters['Projects/allProjects'];
    }

    public facilityAction(facilityId: number, action: string) {
        if (this.actionType === action && this.activeFacility === facilityId) {
            this.resetActiveFacility();
            return;
        }

        this.actionType = action;
        this.activeFacility = facilityId;

        this.$store.commit(Mutations.SET_FACILITY_FORM_MODE, action);
        this.$store.commit(Mutations.SET_ACTIVE_ADMIN_FACILITY, facilityId);

        if (action === 'view') {
            this.$store.dispatch(Actions.FETCH_ACTIVE_ADMIN_FACILITY_PHOTOS, facilityId);
        } else if (action === 'calendar') {
            this.$store.dispatch(Actions.FETCH_ACTIVE_ADMIN_FACILITY_BOOKINGS, facilityId);
        }
    }

    public downloadBookingsSheet(facility) {
      axios({
        url: Endpoints.Admin.SharedFacilities.ACTIVE_ADMIN_FACILITY_BOOKINGS_SHEET(facility.id),
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', facility.name + ' - ' + this.$moment().format('LL') + '.xlsx');
        document.body.appendChild(link);
        link.click();
      });
    }

    public unSelectFacility(facilityId: number) {
        if (this.activeFacility === facilityId) {
            this.resetActiveFacility();
        }
    }

    public resetActiveFacility() {
        this.actionType = '';
        this.activeFacility = null;
        this.$store.commit(Mutations.SET_FACILITY_FORM_MODE, 'default');
        this.$store.commit(Mutations.SET_ACTIVE_ADMIN_FACILITY, null);
        this.$store.commit(Mutations.SET_ACTIVE_ADMIN_FACILITY_PHOTOS, []);
        this.$store.commit(Mutations.SET_ADMIN_ACTIVE_FACILITY_BOOKINGS, []);
    }

    public setCurrentProject(ev: any) {
        this.resetActiveFacility();
        this.$store.dispatch(Actions.FETCH_PROJECT_ALL_FACILITIES, ev.srcElement.value);
    }

    public mounted() {
        this.resetActiveFacility();
        this.$store.dispatch(Actions.FETCH_PROJECTS).then(() => {
            this.$store.dispatch(Actions.FETCH_PROJECT_ALL_FACILITIES, this.projects[0].id);
        });
    }
}
